export default {
  labels: {
    reply: 'Réponse du propriétaire',
  },
  form: {
    reply_text: {
      placeholder: 'Rédigez votre réponse...',
    },
  },
  buttons: {
    generate_reply: 'Générer une réponse',
    submit_reply: 'Envoyer la réponse',
  },
  toasts: {
    failed_to_create_reply: 'Échec de la création de la réponse',
    failed_to_generate_ai_reply: 'Échec de la génération de la réponse IA',
  },
};
